import TableSellType from './table-sell-type';

export default TableSellType;
